<template>
  <div>
    <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
    <DataTable>
      <template #header>
        <span>Education</span>
        
      </template>
      <Column header="Level"/>
      <Column header="Institute"/>
      <Column header="Major/Specialization"/>
      <Column header="Year"/>
      <Column header="GPA/Score"/>
      <Column header="End Date"/>
      <Column header="Action"/>
    </DataTable>
    <Dialog header="Education" :visible.sync="displayBasic" @show="setDate"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="name">Level<span style="color:red">*</span></label>
          <InputText v-model.trim="level" id="name"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="institute">Institute</label>
          <InputText v-model.trim="institute" id="institute"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="major">Major/Specialization</label>
          <InputText v-model.trim="specialization" id="major"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="year">Year</label>
          <InputText v-model.trim="year" id="year"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="gpaScore">GPA/Score</label>
          <InputText v-model.trim="gpaScore" id="gpaScore"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="strtDate">Start Date</label>
          <date-picker v-model="startDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="strtDate"
                     v-model="startDate"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="enDate">End Date</label>
          <date-picker v-model="endDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="enDate"
                     v-model="endDate"/>
        </div>
      </div>
      <template #footer>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <Button class="p-button-raised"
                    :label="!editing?'Add':'Update'"/>
            <Button class="p-button-raised p-button-info" v-if="!editing"
                    label="Add & New"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'education',
  data() {
    return {
      displayBasic: false,
      level: '',
      institute: '',
      specialization: '',
      year: '',
      gpaScore: '',
      startDate: null,
      endDate: null,
      editing: false,
      englishDateEnabled: true
    }
  },
  methods: {
    setDate() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.startDate = this.$store.getters.nepaliNewDate
        this.endDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.startDate = new Date().toISOString().slice(0, 10)
      this.endDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#strtDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.startDate = $('#strtDate').val()
        }
      })
      $('#enDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.endDate = $('#enDate').val()
        }
      })
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    InputMask,
    DatePicker
  }
}

</script>



// WEBPACK FOOTER //
// education.vue?2900314c